import { http } from '../../../../api/http';
import type { LiquidacionCalculo, LiquidacionBeneficios, GrabarLiquidacionRequest } from '../types/liquidacion';

const ENDPOINT = '/planilla/liquidacion';

export class LiquidacionService {
  static async calcular(idTrabajador: number, fechaCese: string): Promise<LiquidacionCalculo> {
    const response = await http.get(`${ENDPOINT}/calcular/${idTrabajador}`, { params: { fechaCese } });
    return response.data;
  }

  static async grabar(request: GrabarLiquidacionRequest): Promise<LiquidacionBeneficios> {
    const response = await http.post(`${ENDPOINT}/grabar`, request);
    return response.data;
  }

  static async getAll(idTrabajador?: number): Promise<LiquidacionBeneficios[]> {
    const response = await http.get(ENDPOINT, { params: { idTrabajador } });
    return response.data;
  }

  static async getById(id: number): Promise<LiquidacionBeneficios> {
    const response = await http.get(`${ENDPOINT}/${id}`);
    return response.data;
  }

  static async anular(id: number): Promise<LiquidacionBeneficios> {
    const response = await http.put(`${ENDPOINT}/${id}/anular`);
    return response.data;
  }
}
